interface LoadingProps {
  centerText?: string;
}

export const KoruLoading: React.FC<LoadingProps> = ({ centerText }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800/50">
      <div className="relative w-56 h-56">
        {/* Spinner ring */}
        <div className="absolute inset-0 rounded-full border-8 border-[#62d29e]/30 bg-white border-t-[#62d29e] animate-spin z-0"></div>
        <div className="absolute inset-0 rounded-full border-8 border-[#62d29e]/50 bg-[#56dac5]/10 border-t-[#62d29e] animate-spin z-0"></div>
        {/* Stationary center */}
        {centerText ? (
          <div className="absolute inset-3 flex items-center justify-center z-10 ">
            {centerText}
          </div>
        ) : null}
      </div>
    </div>
  );
};
